import axios from "axios";
import { API_BASE_CMS, API_BASE_IMG_URl } from "helper/environment";
const includes = [
    "field_project_image.field_media_image",
    "field_project_image.field_media_svg_image",
    "field_project_category_list_icon.field_media_image",
    "field_project_category_list_icon.field_media_svg_image",
];
export const ProjectlistApis = async () => {
    const response = await fetch(
        `${API_BASE_CMS}/jsonapi/node/project_list_in_project_page?include=${includes.join(",")}`
    );

    if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
    }

    const { data, included } = await response.json();
    const getImageFromMedia = (mediaId?: string) => {
        if (!mediaId) return { url: null, alt: null };

        const media = included?.find(
        (inc: any) =>
            (inc.type === "media--image" || inc.type === "media--svg_image") &&
            inc.id === mediaId,
        );

        if (!media) return { url: null, alt: null };

        // handle both image and svg relationship fields
        const imageField =
        media.relationships?.field_media_image?.data ||
        media.relationships?.field_media_svg_image?.data;

        if (!imageField?.id) return { url: null, alt: null };

        const file = included?.find(
        (inc: any) => inc.type === "file--file" && inc.id === imageField.id,
        );

        const fileUrl = file?.attributes?.uri?.url
        ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
        : null;

        const altText = imageField?.meta?.alt || media?.attributes?.name || "";

        return {
        url: fileUrl,
        alt: altText,
        };
    };


    const formatted = data.map((item: any) => {
        const iconId =
        item.relationships?.field_project_category_list_icon?.data?.id;

        const imgId =
        item.relationships?.field_project_image?.data?.id;

        return {
            id: item.attributes.drupal_internal__nid,
            title: item.attributes.title,
            status: item.attributes.status,
            page_display: item.attributes.field_page_display || "",
            description: item.attributes.field_project_description,
            project_status: item.attributes.field_project_status,
            project_tab: item.attributes.field_project_tab_data,
            project_tag: item.attributes.field_project_tags,
            project_type: item.attributes.field_project_type,
            project_category_list:
                item.attributes.field_project_category_list,
            fileImg: getImageFromMedia(imgId),
            fileIcon: getImageFromMedia(iconId),
        };
    });

    return formatted;
};
export const ProjectlistApi = async () => {
  let url = `${API_BASE_CMS}/jsonapi/node/project_list_in_project_page?page[limit]=50&include=${includes.join(",")}`;

  let allData: any[] = [];
  let allIncluded: any[] = [];

  while (url) {
    //console.log(url,'project url');
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }

    const { data, included, links } = await response.json();

    allData = [...allData, ...(data || [])];
    allIncluded = [...allIncluded, ...(included || [])];

    // next page
    url = links?.next?.href || null;
    // url = links?.next?.href ? links.next.href.replace(/^http:\/\//, "https://") : null;
  }

  const getImageFromMedia = (mediaId?: string) => {
    if (!mediaId) return { url: null, alt: null };

    const media = allIncluded?.find(
      (inc: any) =>
        (inc.type === "media--image" || inc.type === "media--svg_image") &&
        inc.id === mediaId
    );

    if (!media) return { url: null, alt: null };

    const imageField =
      media.relationships?.field_media_image?.data ||
      media.relationships?.field_media_svg_image?.data;

    if (!imageField?.id) return { url: null, alt: null };

    const file = allIncluded?.find(
      (inc: any) => inc.type === "file--file" && inc.id === imageField.id
    );

    const fileUrl = file?.attributes?.uri?.url
      ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
      : null;

    const altText = imageField?.meta?.alt || media?.attributes?.name || "";

    return {
      url: fileUrl,
      alt: altText,
    };
  };

  const formatted = allData.map((item: any) => {
    const iconId =
      item.relationships?.field_project_category_list_icon?.data?.id;

    const imgId =
      item.relationships?.field_project_image?.data?.id;

    return {
      id: item.attributes.drupal_internal__nid,
      title: item.attributes.title,
      status: item.attributes.status,
      project_date: item.attributes.field_project_date || "",
      description: item.attributes.field_project_description,
      home_display: item.attributes.field_home_page_display,
      project_tab: item.attributes.field_project_tab_data,
      project_tag: item.attributes.field_project_tags,
      project_type: item.attributes.field_project_type,
      project_category_list: item.attributes.field_project_category_list,
      fileImg: getImageFromMedia(imgId),
      fileIcon: getImageFromMedia(iconId),
    };
  });

  //console.log("All Projects:", formatted);

  return formatted;
};

const includess = [
    "field_project_image",
    "field_project_image.field_media_image",
    "field_project_image.field_media_svg_image",
    "field_project_paragraph_list",
    "field_project_paragraph_list.field_project_paragraph_image",
    "field_project_paragraph_list.field_project_paragraph_image.field_media_image",
    "field_project_paragraph_list.field_project_paragraph_image.field_media_svg_image",
];
export const ProjectpageApi = async (uuid: string) => {
    const urls = 
        `${API_BASE_CMS}/jsonapi/node/project_page/${uuid}?include=${includess.join(",")}`
   

    // if (!response.ok) {
    //     throw new Error(`HTTP error ${response.status}`);
    // }

  const response = await axios.get(urls);

  const node = response.data.data; // single object
  const included = response.data.included || [];
    const findIncluded = (type: string, id: string) =>
    included.find((item: any) => item.type === type && item.id === id);
    const getImageFromMedia = (mediaId?: string) => {
        if (!mediaId) return { url: null, alt: null };

        const media = included?.find(
        (inc: any) =>
            (inc.type === "media--image" || inc.type === "media--svg_image") &&
            inc.id === mediaId,
        );

        if (!media) return { url: null, alt: null };

        // handle both image and svg relationship fields
        const imageField =
        media.relationships?.field_media_image?.data ||
        media.relationships?.field_media_svg_image?.data;

        if (!imageField?.id) return { url: null, alt: null };

        const file = included?.find(
        (inc: any) => inc.type === "file--file" && inc.id === imageField.id,
        );

        const fileUrl = file?.attributes?.uri?.url
        ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
        : null;

        const altText = imageField?.meta?.alt || media?.attributes?.name || "";

        return {
        url: fileUrl,
        alt: altText,
        };
    };
const Image = node.relationships?.field_project_image?.data?.id ?? "";
  const slides = node.relationships?.field_project_paragraph_list?.data
    ?.map((ref: any) => {
    const slide = findIncluded(ref.type, ref.id);
    if (!slide) return null;

        return {
            id: slide?.attributes?.drupal_internal__id || 0,
            description: slide?.attributes?.field_project_paragraph_descript?.value || "",
            number: slide?.attributes?.field_project_paragraph_number || "",
            unit: slide?.attributes?.field_project_paragraph_unit || "",
            images: getImageFromMedia(slide.relationships?.field_project_paragraph_image?.data?.id ?? "")
        };
    })
    .filter(Boolean) || [];
    return {
    id: node.id,
    status: node.attributes?.status,
     title: node.attributes?.title,
     subtitle: node.attributes?.field_subtitle || "",
    images: getImageFromMedia(Image),
    description: node.attributes?.field_project_description?.value || "",
    slides
    };
};